import { Alert } from '@material-ui/lab';

import { useUserTagDescription } from './hooks';

import makeClasses from './UserTagDescription.style';

import type { AlertProps } from '@material-ui/lab/Alert/Alert';
import type { UserTagType } from 'shared/domain';

export function UserTagDescription(props: Props) {
  const { userTag = 'own', children, ...alertProps } = props;

  const hasChildren = Boolean(children);

  const { lang } = useUserTagDescription({ userTag });

  const _classes = makeClasses();

  return (
    <Alert
      role='definition'
      severity='info'
      variant='standard'
      classes={{ root: _classes.root, message: _classes.message }}
      {...alertProps}
    >
      {hasChildren ? children : lang.content}
    </Alert>
  );
}

interface Props extends AlertProps {
  userTag: UserTagType;
}
